import { useDispatch, useSelector } from 'react-redux'
import { t } from 'ttag'
import { useEffect } from 'react'

import { getTenantInfo } from '@main/actions/educator'
import LinkGenerator from '@main/containers/educators/LinkGenerator'
import linkGeneratorSvg from '@h2/assets/svg/blockGraphics/linkGenerator.svg'

import { Promotion } from '../../promotion'

const LinkGeneratorBox = () => {
  const heading = t`Link Generator`
  const educatorPortal = useSelector(state => state.educatorportal)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getTenantInfo())
  }, [dispatch])

  return (
    <Promotion
      color="blue"
      variant="navigator"
      modalBody={<LinkGenerator educatorPortal={educatorPortal} />}>
      <Promotion.Heading>{heading}</Promotion.Heading>
      <Promotion.Text>
        {t`Want to add a link to us on your website? Use the link builder to create HTML that you can use on your site.`}
      </Promotion.Text>
      <Promotion.Button>{t`Start promoting`}</Promotion.Button>
      <Promotion.Image src={linkGeneratorSvg} />
    </Promotion>
  )
}

export { LinkGeneratorBox }
